<!-- src/components/MobileAlert.vue -->
<template>
    <div class="mobile-alert" v-if="showMobileAlert">
      <div class="alert-content">
        <i class="fas fa-mobile-alt"></i>
        <h3>{{ $t('mobile.title') }}</h3>
        <p>{{ $t('mobile.message') }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MobileAlert-View',
    data() {
      return {
        showMobileAlert: false,
        minWidth: 768  
      }
    },
    created() {
      this.checkScreenSize();
      window.addEventListener('resize', this.checkScreenSize);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
      checkScreenSize() {
        this.showMobileAlert = window.innerWidth < this.minWidth;
      }
    }
  }
  </script>
  
  <style scoped>
  .mobile-alert {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #111c44;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .alert-content {
    padding: 2rem;
    max-width: 90%;
  }
  
  .alert-content i {
    font-size: 4rem;
    color: #dc3545;
    margin-bottom: 1rem;
  }
  
  .alert-content h3 {
    color: #dc3545;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }
  
  .alert-content p {
    color: #666;
    font-size: 1rem;
    line-height: 1.5;
  }
  
  @media (min-width: 768px) {
    .mobile-alert {
      display: none;
    }
  }
  </style>